/**
 * Taxonomy жагсаалт (parentId, position) → мод → шүүлтийн жагсаалт (depth).
 */

export function listToCategoryTree(items) {
  if (!Array.isArray(items) || items.length === 0) return [];

  const byParent = new Map();
  for (const item of items) {
    const pid = item.parentId ? String(item.parentId) : "__root__";
    if (!byParent.has(pid)) byParent.set(pid, []);
    byParent.get(pid).push(item);
  }

  const sortByPosition = (a, b) => (a.position ?? 0) - (b.position ?? 0);

  function build(parentKey) {
    const rows = (byParent.get(parentKey) || []).sort(sortByPosition);
    return rows.map((row) => ({
      ...row,
      children: build(String(row._id)),
    }));
  }

  return build("__root__");
}

export function flattenCategoryTree(nodes, depth = 0, acc = []) {
  if (!nodes?.length) return acc;
  for (const n of nodes) {
    const { children, ...rest } = n;
    acc.push({ ...rest, depth });
    flattenCategoryTree(children || [], depth + 1, acc);
  }
  return acc;
}
